import React from "react";
import noResult from "assets/img/somethingWrong.svg";
import { Button } from "@windmill/react-ui";

const Somethingwentwrong = ({ title }) => {
  return (
    <div className="flex flex-col items-center justify-center p-5 pt-8">
      <img
        className="my-4"
        src={noResult}
        alt="somethingWrong"
        style={{ maxWidth: "200px", width: "80%" }}
      />
      <h2 className="text-lg md:text-xl lg:text-2xl xl:text-2xl text-center mt-2 font-medium font-serif text-gray-600">
        {title}.
        <span role="img" aria-labelledby="img"></span>
      </h2>
      <Button
        onClick={() => window.location.reload()}
        className="mb-6 mt-2 px-4 py-2 border-2 border-black text-black rounded bg-white"
        style={{ backgroundColor: "white" }}
      >
        Retry
      </Button>
    </div>
  );
};

export default Somethingwentwrong;
